import React from 'react'
import CommonPage from './CommonPage'

function CommonNoIndexPage({ children }) {
  return <CommonPage noIndex>{children}</CommonPage>
}

export default CommonNoIndexPage
